import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const globalAPI = createApi({
  reducerPath: 'GlobalAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api' }),
  endpoints: (build) => ({
    getPublisherList: build.query({
      query: (term) => ({
        url: `/Global/GetPublisherList`,
        credentials: 'include',
        params: {
          term,
        },
      }),
    }),
    getPartnersKeys: build.query({
      query: () => ({
        url: `/partner_audience/partners/getkeys`,
      }),
    }),
    getSetupSteps: build.query({
      query: () => ({
        url: `/Onboarding/GetSetupSteps`,
        method: 'GET',
      }),
    }),
  }),
});
